import { render, staticRenderFns } from "./messages-badge-state.vue?vue&type=template&id=5c37583b&"
import script from "./messages-badge-state.vue?vue&type=script&lang=js&"
export * from "./messages-badge-state.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports